export const showAPIErrorToast = (err) => {
  console.error(err);

  if (!err?.response?.data?.error?.message) {
    window.Toast.error("서버와 통신 중 에러가 발생하였습니다.");
    return;
  }

  window.Toast.error(err.response.data.error.message);
};
